<template>
  <UiInputSearchVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
export default {
  name: 'UiInputSearchVee',
  inheritAttrs: false,
  props: {
    name: { type: String, default: undefined },
    label: { type: String, default: undefined },
    placeholder: { type: String, default: undefined },
    modelValue: { type: String, required: true as const },
  },
}
</script>

